import type { Epic } from 'Flux/index.js'
import { projectSlice } from 'Flux/Slice/Project/ProjectSlice.js'
import { catchError, filter, mergeMap, of } from 'rxjs'
import { withLatestFrom } from 'rxjs/operators'

export const GetAllProjectsEpic: Epic = (action$, state$, { [projectSlice.name]: project, ProjectRepository }) =>
  action$.pipe(
    filter(project.getAllProjectsRequest.match),
    withLatestFrom(state$),
    mergeMap(([action]) => {
      return ProjectRepository.getAllProjects(action.payload).pipe(
        mergeMap((response) => of(project.getAllProjectsRequestSuccess(response))),
        catchError((error) => of(project.getAllProjectsRequestFailure({ error })))
      )
    })
  )
